/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";
import TEXT from "../../../utils/globalText.js";
import { globalTextFormat } from "../../../utils/globalTextFormat.js";
import AssignLabels from "../../_utils/AccountCreationComponents/AssignLabels/index.jsx";
import CommonLayout from "../../_utils/CommonLayout/index.jsx";
import CommonAssignLabelPopup from "../../_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import DynamicAdditionalFields from "../../_utils/TransactionCommonComponents/DynamicAdditionalFields.jsx";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization/index.js";

const FieldForceCreateTxnAdditionalDetails = (props) => {
  const dropdownRefs = useRef(null);
  const disableCategories = true;
  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [loading, setLoading] = useState(false);
  const [dropdowns, setDropdowns] = useState({});
  const labelActionDispatchedRef = useRef(false);
  // const [isFocused, setIsFocused] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);

  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const closeDropdowns = () => {
    setDropdowns((prev) => {
      const newDropdowns = Object.keys(prev).reduce((acc, key) => {
        acc[key] = { ...prev[key], isOpen: false };
        return acc;
      }, {});
      return newDropdowns;
    });
  };

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (
      value < GlobalConfiguration.lengthCheckZero ||
      value.length > GlobalConfiguration.gstLength
    ) {
      return;
    }

    props?.setQuantities((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: Number(value) || GlobalConfiguration.lengthCheckZero,
        data_typeChan: data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleInputChange = (e, data_type) => {
    if (
      data_type === "numeric" &&
      e.target.value.length > GlobalConfiguration.gstLength
    )
      return;
    if (e.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: data_typeChan,
    } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (f) => f.name === name,
      );

    let updatedData = { ...props.additionalData };

    const isNonTrimmedType = [
      "date",
      "year",
      "toggle",
      "time",
      "quantity",
      "from_year_to_year",
      "month_year",
      "date_range",
      "multi_select_list",
      "upload",
    ].includes(data_typeChan);

    const trimmedValue =
      isNonTrimmedType || typeof value !== "string"
        ? value
        : value.replace(/^\s+/, "");

    if (field?.data_type === "month_year") {
      if (typeof value === "object" && value?.month && value?.year) {
        const monthNumber = (
          months.indexOf(value.month) + GlobalConfiguration.lengthCheckOne
        )
          .toString()
          .padStart(GlobalConfiguration.lengthCheckTwo, "0");

        updatedData[name] = `${monthNumber}/${value.year}`;
      } else if (typeof value === "string" && value.includes("/")) {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "date_range") {
      if (typeof value === "string" && value.includes("-")) {
        const [start, end] = value.split("-").map((v) => v.trim());
        updatedData[name] = {
          start_date: start,
          end_date: end,
        };
      } else if (typeof value === "object") {
        updatedData[name] = value;
      }
    } else if (field?.data_type === "numeric") {
      if (trimmedValue === "" || /^\d+$/.test(trimmedValue)) {
        updatedData[name] = trimmedValue;
      }
    } else {
      updatedData[name] = trimmedValue;
    }

    props.setAdditionalData(updatedData);

    if (field?.data_type === "list") {
      setDropdowns((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          selectedOption: trimmedValue,
        },
      }));
    }

    return;
  };

  useEffect(() => {
    if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "time"
    ) {
      const timeStr = props?.copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        props?.copyData?.title,
        props?.copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      props?.setTimeData((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,
          value: props?.copyData?.value,
          data_typeChan: props?.copyData?.data_type,
        },
      });

      let data = new Date(props?.copyData?.value);

      props?.setStartDateCal((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,
          [key]: data,
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        props?.copyData?.value || 0,
        props?.copyData?.title,
        props?.copyData?.data_type,
        `${props?.copyData?.title}_${props?.copyData?.data_type}`,
      );

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = props?.copyData?.value.split("/");

      const monthIndex =
        parseInt(monthStr, GlobalConfiguration.panLength) -
        GlobalConfiguration.lengthCheckOne;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [
        monthName,
        parseInt(yearStr, GlobalConfiguration.panLength),
      ];

      props?.setSelectedValueMonth((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setSelectedValue((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: props?.copyData?.value?.from,

            to: props?.copyData?.value?.to,
          },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date_range"
    ) {
      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [props?.copyData]);

  useEffect(() => {
    props.BenEnableNextButton(true);
  }, []);

  useEffect(() => {
    if (!props.additionalData) return;

    const storeData =
      props.txnPayLoad.selectedCategory?.configuration?.data?.map((val) => {
        const dataValue = props.additionalData[val?.name];

        if (dataValue !== undefined && dataValue !== "") {
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(
              dataValue,
              GlobalConfiguration.panLength,
            );
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              return val;
            }
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "multi_select_list") {
          return { ...val, value: [] };
        } else if (val?.data_type === "toggle") {
          return { ...val, value: false };
        } else if (val?.data_type === "hyperlink") {
          return { ...val, value: "" };
        } else if (val?.data_type === "time") {
        } else if (val?.mandatory !== "Y") {
          return { ...val, value: "" };
        }

        return val;
      });

    props.setTxnPayLoad({
      ...props.txnPayLoad,
      mergeCategory: storeData,
    });

    closeDropdowns();
  }, [props.additionalData, props.txnPayLoad.selectedCategory]);

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("AvailableLabelsTxn");
    const accountTxnRaw = sessionStorage.getItem("AvailableLabels");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    const uniqueLabels = [...new Set(initialLabels)];

    setLabels(uniqueLabels);
  }, []);

  useEffect(() => {
    const ownerLabels = props?.txnPayLoad?.ownerLabels || [];
    const labels = props?.txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [props?.txnPayLoad?.ownerLabels, props?.txnPayLoad?.labels]);

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    if (!finalLabels) return;

    const currentOwnerLabels = props?.txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = finalLabels.filter((label) =>
      currentOwnerLabels.includes(label),
    );

    const newOtherLabels = finalLabels.filter(
      (label) => !currentOwnerLabels.includes(label),
    );

    props?.setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (focused) {
      return length >= GlobalConfiguration.accountminLength
        ? "verified"
        : "typing";
    } else {
      if (length === GlobalConfiguration.lengthCheckZero) return "default";
      if (length < GlobalConfiguration.accountminLength) return "error";
      return "verified";
    }
  };

  const unassignCategories = props?.categories?.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories?.filter(
    (unassignCategory) => !props?.category?.includes(unassignCategory.name),
  );

  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() === category?.trim().toLowerCase(),
    );
    if (props?.selectedCategory?.name === category) {
      return;
    }
    if (props?.txnPayLoad?.selectedCategory?.name === props?.catName) {
      props?.setCatSelect(false);
    }
    props?.setSelectedCategory(categoryData);
    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setDateRangeEnabled(false);
    props?.setShowDatePicker({});
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setShowDatePickerCal({});
    props?.setStartDateCal({});
    props?.setIsSingleDateSelected(false);
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  useEffect(() => {
    if (props?.mapingCat === "renderCat" && props?.catSelect) {
      handleCategorySelect(beneTxnAccountData?.transaction?.[0]?.category);
      props?.setMapingCat(null);
    }
  }, [props?.mapingCat, props?.catSelect]);

  const handleUnassignNavigate = (id) => {
    toast.info("Feature coming soon", toast_position);
    // navigate(
    //   `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_category/${props.txnPayLoad.beneAccountId}`,
    // );
  };

  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={showLabelModal}
            setPayload={props?.setTxnPayLoad}
            txnPayLoad={props?.txnPayLoad}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            labelActionDispatchedRef={labelActionDispatchedRef}
            loading={loading}
            setLoading={setLoading}
            type="create"
          />
        </div>
      )}
      <div
        className="p-mobile-padding-l w-width-full Qlg:h-height-full Qsmd:pt-padding-lg h-auto justify-between items-start px-padding-md Qlg:px-padding-base pb-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div
            className="w-width-full max-h-auto rounded-border-radius-md"
            style={{ scrollbarWidth: "none" }}
          >
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] pb-padding-xl ${props?.type === "PayFieldForceTxn" && "opacity-light-opacity pointer-events-none"}`}
            >
              <CategorySelector
                beneAccountId={beneAccountId}
                category={props?.category}
                selectedCategory={props?.selectedCategory}
                unassignCategories={unassignCategories}
                unassignlength={unassignlength}
                disableCategories={disableCategories}
                handleCategorySelect={handleCategorySelect}
                handleUnassignNavigate={handleUnassignNavigate}
                previewMode={false}
                variant={
                  props?.type === "PayFieldForceTxn" ? "selected" : "list"
                }
                enableSearch
                showUnassignCTA={true}
              />
            </div>
          </div>

          <div
            className={`h-auto w-width-full pb-padding-md flex flex-col gap-gap-md `}
          >
            <div
              className={`${props.type === "PayFieldForceTxn" && " opacity-light-opacity pointer-events-none"}`}
            >
              <DynamicAdditionalFields
                headerText={globalTextFormat(
                  TEXT.CATEGORY_SPECIFIC_DETAILS,
                  [0, 1, 2],
                )}
                mergeCategory={props?.txnPayLoad?.mergeCategory}
                additionalData={props.additionalData}
                setAdditionalData={props.setAdditionalData}
                hyperLink={props.hyperLink}
                setHyperLink={props.setHyperLink}
                timeData={props.timeData}
                setTimeData={props.setTimeData}
                quantities={props.quantities}
                setQuantities={props.setQuantities}
                uploadedFiles={props.uploadedFiles}
                setUploadedFiles={props.setUploadedFiles}
                startDate={props.startDate}
                endDate={props.endDate}
                setStartDate={props.setStartDate}
                setEndDate={props.setEndDate}
                selectedValue={props.selectedValue}
                setSelectedValue={props.setSelectedValue}
                selectedValueMonth={props.selectedValueMonth}
                setSelectedValueMonth={props.setSelectedValueMonth}
                initialRefactorAdditionalDetail={
                  props.initialRefactorAdditionalDetail
                }
                setInitialRefactorAdditionalDetail={
                  props.setInitialRefactorAdditionalDetail
                }
                previewImages={props.previewImages}
                setPreviewImages={props.setPreviewImages}
                onInputChanged={(name, value, data_type) => {
                  handleInputChange({
                    target: {
                      name,
                      value,
                      data_typeChan: data_type,
                    },
                  });
                }}
              />
            </div>
            <AssignLabels
              setLabelpopup={setShowLabelModal}
              labels={selectedLabelsCreate}
              subText1={TEXT?.LABELS_USAGE_NOTE}
              // subText2={TEXT?.LABELS_AUTO_ASSIGNED_NOTE}
              isOptional={true}
            />
          </div>
        </CommonLayout>

        <div className="w-width-full Qmd:hidden block my-margin-xl lg:my-margin-base"></div>
      </div>
    </>
  );
};

export default FieldForceCreateTxnAdditionalDetails;
